import React from "react"

export const VehicleCardHeader2 = ()=> {
    return (
        <React.Fragment>
            <div style={{ height: 30, width: '100%', marginTop: -10 }}>
                <h4 style={{ color: 'grey' }}>Autres informations sur le véhicule</h4>
            </div>
        </React.Fragment>
    )
}

export default VehicleCardHeader2;